import React from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { openSearchModal } from "@/modules/hub/features/Search/slices/searchSlice";
import { RootState } from "@/app/rootReducer";
import { selectActiveSessionCompanyName } from "@/modules/hub/features/UserAppSettings/selectors/userAppSettingsSelectors";

const HubHero: React.FC = () => {
  const dispatch = useDispatch();
  const userAppSettings = useSelector(
    (state: RootState) => state.userAppSettings.userAppSettings,
  );
  const companyName = useSelector(selectActiveSessionCompanyName);

  const firstName = userAppSettings?.firstName || "there";
  const displayCompanyName = companyName || "your hub";

  const handleSearchClick = () => {
    dispatch(openSearchModal());
  };

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-[rgb(109,21,51)] to-[rgb(78,15,36)]">
      {/* Subtle accent lines for prestige */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />

      <div className="relative mx-auto max-w-5xl px-4 py-16 sm:px-6 md:py-20">
        <div className="text-center">
          {/* Headline - Larger and more prominent */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-white tracking-wide mb-8">
            Welcome back, {firstName}
          </h1>

          {/* Hero Search Bar - Minimal */}
          <div className="mx-auto max-w-xl">
            <button
              onClick={handleSearchClick}
              className="group relative w-full"
              type="button"
            >
              <div className="relative flex items-center rounded-md border border-white/20 bg-white/5 backdrop-blur-sm px-4 py-3 transition-all duration-200 hover:border-white/30 hover:bg-white/10">
                <MagnifyingGlassIcon
                  className="h-4 w-4 text-gray-400 transition-colors group-hover:text-white"
                  aria-hidden="true"
                />
                <span className="ml-3 flex-1 text-left text-sm text-gray-300 group-hover:text-white transition-colors">
                  Search events, resources, news...
                </span>
                <kbd className="hidden sm:inline-flex items-center gap-0.5 rounded border border-white/20 bg-white/10 px-1.5 py-0.5 text-xs font-light text-gray-300">
                  <span className="text-xs">⌘</span>K
                </kbd>
              </div>
            </button>

            {/* Helper Text - Minimal */}
            <p className="mt-2 text-xs text-gray-500 font-light">
              Press{" "}
              <kbd className="rounded border border-gray-700 bg-gray-800/50 px-1 py-0.5 text-xs font-light text-gray-400">
                ⌘K
              </kbd>{" "}
              to search from anywhere
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubHero;
